<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formArticle">
      <div class="ps-2 pe-2 pb-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]='"/article"' [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteArticle()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="articleContract.userNameCreate"
              [createDate]="articleContract.createDate" [userNameUpdate]="articleContract.userNameUpdate"
              [updateDate]="articleContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-7 col-12">
            <div class="row">
              <div class="col-lg-2 col-md-2 col-sm-2 col-4">
                <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeArticle()"></app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-4">
                <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"
                  [maxLength]="20"></app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-4">
                <app-custom-input-text formControlName="alterCode2" [labelText]="'Cód. Alterno2'"
                  [maxLength]="20"></app-custom-input-text>
              </div>
              <div class="col-lg-3 col-md-2 col-sm-2 col-7">
                <app-custom-select formControlName="typeArticleId" [labelText]="'Tipo Artículo'"
                  [list]="listTypeArticle" [required]="true" (onChangeSelect)="changeTypeArticleId()">
                </app-custom-select>
              </div>
              <div class="col field-state">
                <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateArticle">
                </app-custom-tag>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-2 col-2 d-flex align-items-end">
                <app-custom-button [title]="titleStateArticle" [icon]="'pi pi-undo'"
                  (onClick)="changeStateArticle()"></app-custom-button>
              </div>
              <div class="col-lg-5 col-md-5 col-sm-6 col-12">
                <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true" [maxLength]="300"
                  (onChangeTextOnBlur)="getArticleByName()"></app-custom-input-text>
              </div>
              <div *ngIf="genericArticle" class="col-lg-4 col-md-4 col-sm-6 col-12">
                <app-custom-autocomplete formControlName="genericId" [labelText]="'Genérico'"
                  [list]="listArticleGeneric" (onChangeSelect)="validateArticleGeneric($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-12">
                <app-custom-select formControlName="typeInventoryId" [labelText]="'Tipo Inventario'"
                  [list]="listTypeInventory" [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-autocomplete formControlName="familyId" [labelText]="'Familia'" [list]="listFamily"
                  [required]="true">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-autocomplete formControlName="subgroupId" [labelText]="'Subgrupo'" [list]="listSubgroup"
                  [required]="true" (onChangeSelect)="getSubgroup($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                <app-custom-autocomplete formControlName="groupId" [labelText]="'Grupo'" [list]="listGroup"
                  [required]="true" (onChangeSelect)="getSubgroup($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                <app-custom-select formControlName="rentalUnitId" [labelText]="'Und.Med.Alq.'" [list]="listRentalUnit"
                  [required]="true"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                <app-custom-select formControlName="inventoryUnitId" [labelText]="'Und.Med.Inv.'"
                  [list]="listInventoryUnit" [required]="true"></app-custom-select>
              </div>
              <div *ngIf="!swModuleOrder" class="col-lg-1"></div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-6 checkbox-container">
                <app-custom-checkbox formControlName="occupancyPercentageReport"
                  [labelText]="'% Ocupación'"></app-custom-checkbox>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-6 checkbox-container">
                <app-custom-checkbox formControlName="daysInConstructionSiteReport"
                  [labelText]="'Días en Obra'"></app-custom-checkbox>
              </div>
              <div id="swAffectsInventory" class="col-lg-1 col-md-1 col-sm-1 col-6 checkbox-container">
                <app-custom-checkbox formControlName="swAffectsInventory" [labelText]="'Afecta Inv.'"
                  (onChangeCheckBox)="changeSwAffectsInventory($event)"></app-custom-checkbox>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-1 col-4 checkbox-sw-direct-devolution">
                <app-custom-checkbox formControlName="swDirectDevolutionWorkshop"
                  [labelText]="'Dev. Directa a Taller'"></app-custom-checkbox>
              </div>
              <div *ngIf="swMaintenanceOrder" class="col-lg-1 col-md-1 col-sm-1 col-4 checkbox-container">
                <app-custom-checkbox formControlName="swEquipmentLogbook" [labelText]="'Ficha Técnica'"
                  (onChangeCheckBox)="swEquipmentLogbookUpdate($event)"></app-custom-checkbox>
              </div>
              @if (swPurchaseModule) {
              <div class="col-lg-10 col-md-8 col-sm-8 col-12 mt-1">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                  [rows]="1" [maxLength]="1000"></app-custom-textarea>
              </div>
              }
            </div>
          </div>
          <div class="col-lg-5 col-12">
            <div class="row d-flex justify-content-end">
              <div class="row col-lg-10">
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="weight" [labelText]="'Peso kg'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="areaM2" [labelText]="'Área m2'" [required]="true"
                    [maxFractionDigits]="5"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="replacementValue" [labelText]="'Vr.Reposición'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="saleValue" [labelText]="'Vr.Venta'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="cleaningValue" [labelText]="'Vr.Limpieza'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="minorRepairValue" [labelText]="'Repar. Menor'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-decimal formControlName="mayorRepairValue" [labelText]="'Repar. Mayor'"
                    [required]="true"></app-custom-input-decimal>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-4">
                  <app-custom-input-text formControlName="accountingCostCenter" [labelText]="'C.Costo Contable'"
                    [required]="false" [maxLength]="10"></app-custom-input-text>
                </div>
                @if (swPurchaseModule) {
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto Compra'"
                    [list]="listPurchaseConcept"></app-custom-autocomplete>
                </div>
                <div class="col-12 fieldset-purchase">
                  <p-fieldset legend="Se usa en:">
                    <div class="d-flex flex-wrap mx-2 checkbox-purchase-row">
                      <div class="checkbox-purchase">
                        <app-custom-checkbox formControlName="swSale" [labelText]="'Venta'"></app-custom-checkbox>
                      </div>
                      <div class="checkbox-purchase">
                        <app-custom-checkbox formControlName="swPurchase" [labelText]="'Compra'"
                          (onChangeCheckBox)="changeSwPurchase()"></app-custom-checkbox>
                      </div>
                      <div class="checkbox-purchase">
                        <app-custom-checkbox formControlName="swRequiresPurchaseOrder"
                          [labelText]="'Req.Ord. Compra'"></app-custom-checkbox>
                      </div>
                    </div>
                  </p-fieldset>
                </div>
                }
                @if (!swPurchaseModule) {
                <div class="col-lg-12 col-md-8 col-sm-8 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                    [rows]="1" [maxLength]="1000"></app-custom-textarea>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 d-flex justify-content-between field-buttons field-buttons">
              <app-custom-button [title]="'Adjuntar imágenes'"
                [label]="hasAnyImage() ? 'Ver Imágenes' : 'Adj. imágenes'" [width]="hasAnyImage() ? '7.5rem' : '8rem'"
                [severity]="'success'" [icon]="hasAnyImage() ? 'pi pi-images' : 'pi pi-upload'"
                (onClick)="openAttachImages()"></app-custom-button>
              <app-custom-modal #attachImages [label]="'Adjuntar Imágenes'" [header]="'Adjuntar Imágenes'"
                [children]="componentAttachImages" [inputs$]="inputsForAttachImages$" [width]="'60vw'"
                [output$]="outputAttachImages$" hidden></app-custom-modal>
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- <div class="row" *ngIf="formArticle.get('swEquipmentLogbook')?.value"> -->
  <div class="row" *ngIf="this.articleContract.swEquipmentLogbook">
    <p-accordion value="none" class="accordion-detail" [transitionOptions]="'0ms'">
      <p-accordion-panel value="0">
        <p-accordion-header>Ficha Técnica</p-accordion-header>
        <p-accordion-content>
          <div class="row detail-container">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-equipment-logbook [articleId]="articleId" [companyId]="companyId" [permissionsUser]="permissionsUser"
                [permissionsUser]="permissionsUser" [permissionUpdatable]="permissionUpdatable"
                [userAuthenticated]="userAuthenticated"></app-equipment-logbook>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>